module.exports = __webpack_public_path__ + "media/04.e87424d7.wav";